import { useState } from "react"
import { VideoControl } from "../Interface/index"
import { useCreateAnalyticsEvent } from "../hooks/useCreateAnalyticsEvent"
import Config from "../Config"

const { AnalyticsEvent } = Config

export const useControlVideo = (): VideoControl => {
  const [playing, setShowVideo] = useState<boolean>(false)
  const analyticsEvent = (label: string) => useCreateAnalyticsEvent(label)

  const showVideo = () => {
    setShowVideo(true)
    analyticsEvent(AnalyticsEvent.CheckVideo)
  }

  const closeVideo = () => {
    setShowVideo(false)
  }

  return {
    playing,
    showVideo,
    closeVideo,
  }
}
